(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-appstle-enhancements"] && !Shopify.designMode) return;
  try {
    var waitForAppstle = new MutationObserver(function(mutations, observer) {
    //check for widget availability
    var appstleWidget = document.querySelector("#appstle_subscription_widget0");
    if (!appstleWidget) return;

    //place tooltip inside dom when it doesnt exist
    var insertTolltipElement = function(forceShow) {
        if (!document.querySelector(".appstle-sub-tooltip")) {
            var tooltipElement = document.querySelector(".appstle_tooltip .appstle_tooltip_content");
            var insertTooltip = document.querySelector(".appstle_subscribe_save_text");
            if (!tooltipElement || !insertTooltip) return;
            var appstleTooltipElement = document.createElement('div');
            appstleTooltipElement.className = `appstle-sub-tooltip${forceShow ? " toggled" : ""}`;
            appstleTooltipElement.innerHTML = tooltipElement.innerHTML;

            insertTooltip.appendChild(appstleTooltipElement);
        }
    };

    var appstleChanged = function() {

        //ensure click state on main element as appstle changes per click/change and rewrites the entire widget
        if (!appstleWidget.classList.contains("mouse-initted")) {
            appstleWidget.classList.add("mouse-initted");

            document.addEventListener("click", function(e) {
                if (window.innerWidth > 1023) return;
                var tooltip = document.querySelector(".appstle-sub-tooltip");

                if (tooltip&& tooltip.classList.contains("toggled")) {
                    tooltip.classList.remove("toggled");
                }
            });

            //clicks for mobile
            appstleWidget.addEventListener("click", function(e) {
                var tooltipHolder = e.target.closest(".appstle_subscribe_save_text");
                if (!tooltipHolder || window.innerWidth > 1023) return;
                var toolTip = tooltipHolder.querySelector(".appstle-sub-tooltip");

                if (!toolTip || (toolTip && !toolTip.classList.contains("toggled"))) {
                    setTimeout(function() { insertTolltipElement(true); }, 500);
                }
            });

            //mouse over for desktop
            appstleWidget.addEventListener("mouseover", function(e) {
                if (window.innerWidth <= 1023) return;

                var element = e.target.closest(".appstle_subscribe_save_text");
                if (!element) return;
                if (!element.contains(e.relatedTarget)) {
                    var toolTip = element.querySelector(".appstle-sub-tooltip");
                    if (!toolTip) {
                        insertTolltipElement(true);
                    } else
                        toolTip.classList.add("toggled");
                }
            });

            //mouse out for desktop
            appstleWidget.addEventListener("mouseout", function(e) {
                if (window.innerWidth <= 1023) return;
                var element = e.target.closest(".appstle_subscribe_save_text");

                if (!element) return;

                if (!element.contains(e.relatedTarget)) {
                    var toolTip = element.querySelector(".appstle-sub-tooltip");
                    if (!toolTip) return;
                    toolTip.classList.remove("toggled");
                }
            });
        }
    };

    appstleChanged();
    var appstleObserver = new MutationObserver(function() {
        appstleChanged();
    });

    appstleObserver.observe(appstleWidget, {
        childList: true,
        subtree: true
    });


    //disconnect main observer since we have appstle observer
    observer.disconnect();
});

//wait for appstle widget to become avilable then disconnect and only observe appstle mutations since appstle takes some time to inject
//Shopify bundles every snippet's {% javascript %} into one file that also loads
//for members, so only start when this snippet rendered on the page
if (document.querySelector(".js-appstle-enhancements")) {
    waitForAppstle.observe(document.body, {
        childList: true,
        subtree: true
    });

    //stop waiting if the widget never appears
    setTimeout(function() { waitForAppstle.disconnect(); }, 15000);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-logged-in"] && !Shopify.designMode) return;
  try {
    //tooltip handler
function handleDynamicTooltip(tooltipTrigger, tooltip) {

    var triggerRect = tooltipTrigger.closest(".faux-appstle-element").getBoundingClientRect();

    tooltip.style.position = "fixed";

    var tooltipRect = tooltip.getBoundingClientRect();

    var top = triggerRect.top - tooltipRect.height - 10;
    var left = triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2);

    // If there's no room above, put it below
    if (top < 10) {
        top = triggerRect.bottom + 10;
    }

    // Keep inside left/right of viewport
    if (left < 10) {
        left = 10;
    }

    if (left + tooltipRect.width > window.innerWidth - 10) {
        left = window.innerWidth - tooltipRect.width - 10;
    }

    tooltip.style.top = top + "px";
    tooltip.style.left = left + "px";
}

var infoToggler = document.querySelector(".pdp-tool-tip");
if(infoToggler) {
    infoToggler.addEventListener("click", function() {
        if (window.innerWidth > 1023) return;
        handleDynamicTooltip(this, this.querySelector(".pdp-hover-tool-tip"));
        this.querySelector(".pdp-hover-tool-tip").classList.toggle("toggled");
    });
    infoToggler.addEventListener("mouseenter", function() {
        if (window.innerWidth < 1024) return;
        handleDynamicTooltip(this, this.querySelector(".pdp-hover-tool-tip"));
        this.querySelector(".pdp-hover-tool-tip").classList.add("toggled");
    });

    infoToggler.addEventListener("mouseleave", function() {
        if (window.innerWidth < 1024) return;
        this.querySelector(".pdp-hover-tool-tip").classList.remove("toggled");
    });
}

//Run the theme's own price update once on load, from the selected variant.
//Liquid prints the member price with exact decimal maths; checkout rounds the
//member discount in floating point, which differs by a cent on half-cent prices
//(66.30 -> 56.36 at checkout, 56.35 in Liquid). updatePrice uses checkout's maths.
//Called directly rather than via a fake variant change: single-variant products
//have no selector, and a change event also rewrites the URL to ?variant=.
//(Shopify bundles every snippet's {% javascript %} into one file that also loads
// for non-members, so only act when the member block is actually on the page.)
document.addEventListener("DOMContentLoaded", function() {
    var faux = document.querySelector(".faux-appstle-element");
    if (!faux || typeof cProductForm === "undefined") return;
    var form = faux.closest("form");
    if (!form) return;
    cProductForm.updatePrice(form, {
        price: faux.dataset.variantPrice,
        priceCompare: faux.dataset.variantCompare || ""
    });
});
  } catch(e) { console.error(e); }
})();

})();
